const React = require('react');
const map = require('mn-utils/map');

const DataBlock = require('./DataBlock');

module.exports = (props) => {
  const data = props.data || {};

  const dataArr = [
    {
      title: 'Login',
      value: data.login || '-',
    },
    {
      title: 'Name',
      value: data.name || '-',
    }
  ];

  return (
    <div className="wmax890 layoutRow fxwWrap mh-25 mt10">
      {map(dataArr, (item, i) => (
        <div key={i} className="w1/3 w1/2@m w@m2 mt25 ph25">
          <DataBlock title={item.title} value={item.value} />
        </div>
      ))}
    </div>
  );
};
